module.exports = __webpack_public_path__ + "img/love-letter.387db463.png";